export default "__VITE_ASSET__4273ac3b__"